import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'userManagementExperience.actionListExport'

const UserManagementUserActionListExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default UserManagementUserActionListExportSlice
